import { START_DCR_SIMULATION } from '../actionType';

export const startDCRSimulation = (id, resistanceData, designId, signOffId) => ({
  type: START_DCR_SIMULATION,
  id,
  resistanceData,
  designId,
  signOffId
})